import { Component } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CartaCreateDishProdSelectPage } from '../carta-create-dish-prod-select/carta-create-dish-prod-select';
import { CartaMenuViewPage } from '../../../cartas-menus/carta-menu-view/carta-menu-view';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { CartaMenuServices } from '../../../cartas-menus/services';

/**
 * Generated class for the DishCreateFinishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-create-finish-section',
  templateUrl: 'carta-create-finish-section.html',
})
export class CartaCreateFinishSectionPage {

  type: any;
  section_index: any;
  carta_uid: any;
  section_name: any;
  update_state: boolean = false;
  page_index: any;
  new_carta: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public modalCtrl: ModalController,
    public analyticsServices: AnalyticsServices,
    private cartaMenuServices: CartaMenuServices) {

    this.update_state = this.navParams.get('update_state');
    this.type = this.navParams.get('type');
    this.carta_uid = this.navParams.get('carta_uid');
    this.section_index = this.navParams.get('section_index');
    this.page_index = this.navParams.get('page_index');
    this.section_name = this.navParams.get('section_name');
    this.new_carta = this.navParams.get('new_carta');
  }

  openNextSection() {

    this.globals.GAtrackView('Cartas', 'Cartas - Section new - Create', this.globals.restaurant.email, 'Create/Update', 'Create section new', 'Cartas', this.carta_uid);

    var section = Number(this.section_index);

    this.navCtrl.push(CartaCreateDishProdSelectPage, {
      update_state: false,
      type: this.type,
      carta_uid: this.carta_uid,
      page_index: '0',
      section_index: section + 1,
      new_section: true,
      new_carta: this.new_carta
    });
  }

  finish() {
    this.globals.GAtrackView('Cartas', 'Cartas - Section finish - Create', this.globals.restaurant.email, 'Create/Update', 'Create section finish', 'Cartas', this.carta_uid);
    if (this.new_carta == true) {
      this.analyticsServices.trackingExp('finisher', this.globals.tracking_exp['finisher'], '');
      //save plg_cartamenu_finisher true
      this.cartaMenuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_cartamenu_finisher: true
      });
      this.globals.restaurant.plg_cartamenu_finisher = true;
    }

    this.navCtrl.setRoot(CartaMenuViewPage, {
      type: 'carta',
      state: 'new',
      uid_element: this.carta_uid
    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-finish-section/carta-create-finish-section.ts